export const TIMES = {
  MINUTE: 'MINUTE',
  HOUR: 'HOUR',
  DAY: 'DAY',
  FINISH: 'FINISH',
};

export const SECOND_MILLISECOND = 1000;
export const MINUTE_MILLISECOND = 60 * SECOND_MILLISECOND;
